// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__Dashboard__nF7gS{display:flex;flex-direction:column;height:100vh;width:100vw;background-color:var(--tri-color-fill-tertiary)}`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPages/styles.module.scss"],"names":[],"mappings":"AAAA,2BACE,YAAA,CACA,qBAAA,CACA,YAAA,CACA,WAAA,CACA,+CAAA","sourcesContent":[".Dashboard {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw;\n  background-color: var(--tri-color-fill-tertiary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Dashboard": `sputnik__Dashboard__nF7gS`
};
export default ___CSS_LOADER_EXPORT___;
